export async function lsSet(key: string, obj: Object) {
  if (import.meta.server || !key || obj === undefined) return
  // console.info("save local storage", key, obj);
  try {
    localStorage.setItem(key, JSON.stringify(obj))
  } catch (ex) {
    console.error(ex)
  }
}

export function lsGet<T>(key: string, defaultValue?: T): T {
  if (import.meta.client) {
    let str: string = localStorage.getItem(key)
    try {
      if (str) return <T>JSON.parse(str)
    } catch (ex) {
      console.error(ex)
    }
  }
  return defaultValue
}

export function lsDelete(key: string) {
  if (import.meta.client) {
    localStorage.removeItem(key)
  }
}

export async function ssSet(key: string, obj: Object) {
  if (import.meta.server || !key || obj === undefined) return
  // console.info("save session storage", key, obj);
  try {
    sessionStorage.setItem(key, JSON.stringify(obj))
  } catch (ex) {
    console.error(ex)
  }
}

export function ssGet<T>(key: string, defaultValue?: T): T {
  if (import.meta.client) {
    let str: string = sessionStorage.getItem(key)
    try {
      if (str) return <T>JSON.parse(str)
    } catch (ex) {
      console.error(ex)
    }
  }
  return defaultValue
}

export function ssDelete(key: string) {
  if (import.meta.client) {
    sessionStorage.removeItem(key)
  }
}

export interface LsCacheConfig {
  type: string
  maxCacheSize: number
}

interface CacheObject {
  date: number
  value: any
}

interface LsCache {
  [index: string]: CacheObject
}

function getCacheName(type: string) {
  return 'jps-lscache-' + type
}

export function putLsCache(conf: LsCacheConfig, id: string, value: any) {
  let cache: LsCache = lsGet(getCacheName(conf.type))
  if (!cache) {
    cache = {}
  }
  cache[id] = {
    date: now(),
    value: value,
  }
  let keys = Object.keys(cache)
  if (keys.length > conf.maxCacheSize) {
    let oldestKey = keys
      .map(key => {
        return { key: key, date: cache[key].date }
      })
      .sort((a, b) => a.date - b.date)[0].key
    delete cache[oldestKey]
  }
  lsSet(getCacheName(conf.type), cache)
}

export function getLsCache<T>(conf: LsCacheConfig, id: string): T {
  let cache: LsCache = lsGet(getCacheName(conf.type))
  if (!cache) return null
  if (cache && cache[id]) {
    cache[id].date = now()
    lsSet(getCacheName(conf.type), cache)
    return cache[id].value
  }
}

export function removeLsCache(conf: LsCacheConfig, id: string) {
  let cache: LsCache = lsGet(getCacheName(conf.type))
  if (cache && cache[id]) {
    delete cache[id]
    lsSet(getCacheName(conf.type), cache)
  }
}

export function clearLsCache(conf: LsCacheConfig) {
  lsDelete(getCacheName(conf.type))
}
